import type { InterventionTemplateDuplicateButtonProps } from "./intervention-template-duplicate-button.type";

import { ModelDuplicateButton } from "@/modules/model-duplicate";

import { InterventionTemplateDuplicateForm } from "../intervention-template-duplicate-form";

const InterventionTemplateDuplicateButton = ({
  template,
  ...buttonProps
}: InterventionTemplateDuplicateButtonProps) => {
  return (
    <ModelDuplicateButton
      {...buttonProps}
      modelKey="interventiontemplate"
      form={<InterventionTemplateDuplicateForm template={template} />}
    />
  );
};

export default InterventionTemplateDuplicateButton;
